"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyHandler = exports.SankeyDrawDefaultProps = void 0;
/* eslint @typescript-eslint/no-var-requires: "off" */
const d3 = __importStar(require("d3"));
const react_1 = __importStar(require("react"));
const types_1 = require("./types");
const prop_types_1 = __importDefault(require("prop-types"));
const SankeyUtils_1 = require("./SankeyUtils");
const SankeyLayout_1 = require("./SankeyLayout");
const SankeyDrawFunction_1 = require("./SankeyDrawFunction");
window.d3 = d3;
const SankeyDrawPropTypes = {
    data: prop_types_1.default.shape(types_1.SankeyDataPropTypes).isRequired,
    set_data: prop_types_1.default.func.isRequired,
    animation: prop_types_1.default.bool.isRequired,
    multi_selected_nodes: prop_types_1.default.shape({ current: prop_types_1.default.arrayOf(prop_types_1.default.shape(types_1.SankeyNodePropTypes).isRequired).isRequired }).isRequired,
    multi_selected_links: prop_types_1.default.shape({ current: prop_types_1.default.arrayOf(prop_types_1.default.shape(types_1.SankeyLinkPropTypes).isRequired).isRequired }).isRequired,
    mode_selection: prop_types_1.default.shape({ current: prop_types_1.default.string.isRequired }).isRequired,
    first_selected_node: prop_types_1.default.object.isRequired,
    set_first_selected_node: prop_types_1.default.func.isRequired,
    show_agregation: prop_types_1.default.bool.isRequired, set_show_agregation: prop_types_1.default.func.isRequired,
    agregation_node: prop_types_1.default.string.isRequired,
    is_agregation: prop_types_1.default.bool.isRequired,
    set_alt_key_pressed: prop_types_1.default.func.isRequired,
    min_width_and_height: prop_types_1.default.func.isRequired,
    getLinkValue: prop_types_1.default.func.isRequired,
    token: prop_types_1.default.bool.isRequired,
    set_show_toast_limit_node: prop_types_1.default.func.isRequired
};
exports.SankeyDrawDefaultProps = {
    set_data: () => null,
    animation: false,
    multi_selected_nodes: { current: [] },
    multi_selected_links: { current: [] },
    multi_selected_label: { current: [] },
    mode_selection: { current: 's' },
    first_selected_node: {},
    set_first_selected_node: () => null,
    show_agregation: false, set_show_agregation: () => false,
    agregation_node: '',
    is_agregation: false,
    set_alt_key_pressed: () => false,
    min_width_and_height: () => [],
    getLinkValue: () => [],
    token: false,
    set_show_toast_limit_node: () => false
};
const SankeyDraw = ({ data, set_data = exports.SankeyDrawDefaultProps.set_data, animation, multi_selected_nodes = exports.SankeyDrawDefaultProps.multi_selected_nodes, multi_selected_links = exports.SankeyDrawDefaultProps.multi_selected_links, mode_selection, first_selected_node, set_first_selected_node, show_agregation, set_show_agregation, agregation_node, is_agregation, set_alt_key_pressed, min_width_and_height, getLinkValue, token, set_show_toast_limit_node }) => {
    // const [first_selected_node,set_first_selected_node] = useState({})
    // const diff=require('deep-diff')
    // Il faut détruire les tooltips à chaque passage dans le draw
    d3.selectAll('.sankey-tooltip').remove();
    const sankeyTooltip = d3.select('body')
        .append('div')
        .style('opacity', 0)
        .attr('class', 'sankey-tooltip');
    SankeyUtils_1.setSelectedTags(data, getLinkValue, false);
    sankeyTooltip;
    window.focus();
    d3.select(window).on('keydown', (event) => {
        if (event.keyCode === 18) {
            set_alt_key_pressed(true);
            window.focus();
        }
    });
    d3.select(window).on('keyup', (event) => {
        if (event.keyCode === 18) {
            set_alt_key_pressed(false);
            window.focus();
        }
    });
    const position = data.static_sankey ? 'relative' : 'absolute';
    //const node_font = data.display_style.node_font_family_selected
    // const link_font = data.display_style.link_font_family_selected
    // const test = document.getElementsByClassName('navbar')
    // let margin_top = 0
    // if (test && test.length > 0) {
    //   margin_top = test[0].getBoundingClientRect().height -20
    // }
    // const get_diff = () => {
    //   const diff = require('deep-diff')
    //   const old_data_str = LZString.decompress(localStorage.getItem('data') as string) as string
    //   //Si data existe dans le localStorage 
    //   if (old_data_str != '') {
    //     //On le parse en JSON
    //     const old_data = JSON.parse(old_data_str)
    //     //on va chercher les anciennes différences
    //     // let old_diff = JSON.parse(localStorage.getItem('diff') as string)
    //     const old_diff_str = LZString.decompress(localStorage.getItem('diff') as string) as string
    //     let old_diff = (old_diff_str != '') ? JSON.parse(old_diff_str) : null
    //     const difference = diff(data, old_data)
    //     //Si il y des différences et que le tableau des anciennes différences existes alors on push dedans la nouvelles différence
    //     //sinon on créer un tableau ne contenant que la nouvelle différence
    //     if (difference !== undefined) {
    //       if (old_diff !== undefined && old_diff !== null) {
    //         old_diff.push(difference)
    //       } else {
    //         old_diff = [difference]
    //       }
    //     }
    //     const cmp = LZString.compress(JSON.stringify(old_diff))
    //     if (old_diff !== undefined) {
    //       localStorage.setItem('diff', cmp)
    //     }
    //   }
    // }
    react_1.useEffect(() => {
        var _a, _b;
        if (animation) {
            return;
        }
        [data.width, data.height] = min_width_and_height(data);
        SankeyDrawFunction_1.removeAnimate();
        d3.select('body').style('background-color', data.couleur_fond_sankey);
        // let isDown = false
        // Permet d'affecter une class au svg selon le mode
        if (mode_selection.current == 's') {
            d3.select(' .opensankey #svg').attr('class', 'mode_selection');
        }
        if (mode_selection.current == 'ln') {
            d3.select(' .opensankey #svg').attr('class', 'mode_add_flux');
        }
        const svgSankey = d3.select(' .opensankey #svg');
        svgSankey.attr('viewBox', null);
        svgSankey.style('width', data.width + 'px');
        svgSankey.style('height', data.height + 'px');
        svgSankey
            .call(d3.zoom()
            .filter(ev => {
            return (ev.ctrlKey || ev.metaKey) && ev.buttons == 0;
        })
            .wheelDelta(ev => {
            return -ev.deltaY * (ev.deltaMode === 1 ? 0.05 : ev.deltaMode ? 1 : 0.002);
        })
            .on('zoom', function (evt) {
            evt.transform.x = 0;
            evt.transform.y = 0;
            d3.select(' .opensankey #svg')
                .attr('transform', evt.transform).attr('transform-origin', '0 0');
            svgSankey.attr('viewBox', null);
            const scale_legend = 1 / ((evt.transform.k < 1) ? evt.transform.k : 1);
            d3.select(' .opensankey #svg')
                .style('border', Math.max(1, Math.round(2 / evt.transform.k)) + 'px solid #d3d3d3');
            d3.select(' .opensankey #svg #g_legend').style('transform', 'translate(' + (data.legend_position[0]) + 'px,' + data.legend_position[1] + 'px) scale(' + (scale_legend) + ')');
            d3.select(' .opensankey #svg #g_legend .measurment_scale').html(String(Math.round((data.user_scale / 2) * scale_legend)));
        }))
            .on('dblclick.zoom', null);
        // Fonction permettant de déplacer les éléments dans la zone de dessin, seulement quand on drag avec le boutons du milieu de la souris
        svgSankey
            .call(d3.drag()
            .subject(Object)
            .filter(evt => {
            evt.stopPropagation();
            evt.preventDefault();
            return d3.select(evt.target).attr('id') == 'svg' && evt.which == 2;
        })
            .on('start', () => {
            // Cache les handles des liens
            d3.selectAll(' .opensankey .gg_links rect.handle').attr('fill-opacity', '0');
            d3.selectAll(' .opensankey .gg_links rect.handle').attr('cursor', 'pointer');
            d3.selectAll(' .opensankey .gg_links .drag_zone').attr('cursor', 'pointer');
            d3.selectAll(' .opensankey .gg_links .drag_zone').attr('stroke-opacity', '0');
            d3.selectAll(' .opensankey .gg_links .center_handle').attr('stroke-opacity', '0');
            d3.selectAll(' .opensankey .gg_links .center_handle').attr('fill-opacity', '0');
        })
            .on('drag', function (event) {
            d3.selectAll('.ggg_nodes').attr('transform', (d) => {
                const n = d;
                n.x += event.dx;
                n.y += event.dy;
                return 'translate(' + n.x + ',' + n.y + ')';
            });
            d3.selectAll('.link').attr('d', (d) => {
                const l = d;
                // Get the path of each displayed link
                const path = d3.select('#' + l.idLink).attr('d').split(' ');
                // Each path is splitted into small part of the path then depending on the small part :
                //  - If it's a letter then do nothing
                //  - If it's a string that contains ',' then it's a coordinate of a point as [x,y] and we apply the shift to these values
                //  - If it's a Number alone then it mean that it's either a vertical shift or a horizontale one, 
                //    therefore we search the previous element in the path to see if the shift is vertical 'V' or horizontal 'H'
                // 
                // Then once the subpart of the path are modified, we join the array to reform the path
                const new_path = path.map((p, i) => {
                    // Case when it's a [x,y] coordinates
                    if (p.includes(',')) {
                        const pos = p.split(',');
                        const newPosX = Number(pos[0]) + event.dx;
                        const newPosY = Number(pos[1]) + event.dy;
                        p = '' + newPosX + ',' + newPosY;
                    }
                    // Case when it's a number alone so we search the previous element to know wich shift
                    if (Number(p)) {
                        if (path[i - 1] == 'H') {
                            p = Number(p) + event.x;
                        }
                        else if (path[i - 1] == 'V') {
                            p = Number(p) + event.y;
                        }
                    }
                    return p;
                });
                return new_path.join(' ');
            });
        })
            .on('end', () => {
            set_data(Object.assign({}, data));
        }));
        //Ajout des events sur les l'ajout des noeuds aux click 
        SankeyDrawFunction_1.eventOnSankeyZone(svgSankey, mode_selection, data, set_data, multi_selected_nodes, multi_selected_links, first_selected_node, set_first_selected_node, token, set_show_toast_limit_node);
        SankeyDrawFunction_1.drawGrid(data);
        SankeyDrawFunction_1.update_scale(data.user_scale);
        const shift_top = ((_a = document.getElementsByClassName('MenuNavigation')[0]) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().y) + ((_b = document.getElementsByClassName('MenuNavigation')[0]) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().height);
        d3.select('#svg-container').style('margin-top', shift_top + 'px');
        d3.select(' .opensankey #svg').selectAll('.defsArrow').remove();
        d3.select(' .opensankey #svg').append('defs').attr('class', 'defsArrow');
        // try {
        //   //Permet d'éviter qu'une vue soit stocké en tant que données dans la naviguateur 
        //   if (current) {
        //     get_diff()
        //     const cmp = LZString.compress(JSON.stringify(data))
        //     localStorage.setItem('data', cmp)
        //   }
        // } catch (e) {
        //   console.log(e)
        //   localStorage.clear()
        // }
    });
    let border = '0px';
    if (!data.static_sankey) {
        border = '2px solid #d3d3d3';
    }
    // // Call the function that add nodes to the sankey
    // const draw_nodes=OpenSankeyDrawNodes(data,set_data,
    //   nodes_accordion_ref,links_accordion_ref,
    //   multi_selected_nodes,multi_selected_links,
    //   mode_selection,
    //   first_selected_node,set_first_selected_node,
    //   accordion_ref,button_ref,
    //   set_agregation_node,set_is_agregation,set_show_agregation,
    //   select_node,
    //   alt_key_pressed,
    //   data.static_sankey,
    //   position,removeAnimate)
    // // Call the function that add links to the sankey
    // const draw_links=OpenSankeyDrawLinks(
    //   data,links_accordion_ref,
    //   multi_selected_links,
    //   mode_selection,
    //   accordion_ref,
    //   button_ref,
    //   select_link,
    //   alt_key_pressed,
    //   data.static_sankey,position,node_arrow_visible
    // )
    const width_to_display = ((data.width) ? data.width : window.innerWidth * 0.975);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "span12", style: { 'color': 'black', 'marginLeft': '10px', 'display': 'inline' }, id: 'visualization_div' },
            react_1.default.createElement("div", { id: "svg-container", className: 'opensankey', style: { 'position': position } },
                react_1.default.createElement("svg", { id: 'svg', "transform-origin": '0 0', style: { 'margin': '20px', 'height': data.height, 'width': width_to_display, 'border': border, boxShadow: '2px 2px 2px #d3d3d3,-2px -2px 2px #d3d3d3' }, preserveAspectRatio: "xMidYMin meet", onClick: (ev) => {
                        if ((!ev.ctrlKey && !ev.metaKey) && !ev.shiftKey && mode_selection.current == 's') {
                            SankeyDrawFunction_1.removeAnimate();
                            multi_selected_nodes.current = [];
                            multi_selected_links.current = [];
                            // multi_selected_label.current = []
                            Object.values(data.nodes).filter(n => n.node_visible).forEach(n => d3.select(' .opensankey #' + n.idNode).attr('stroke-width', 0));
                            const visible_links = Object.values(data.links);
                            visible_links.forEach(l => {
                                const sel = d3.selectAll(' .opensankey #gg_' + l.idLink + ' rect');
                                sel.attr('fill-opacity', '0');
                            });
                            set_data(Object.assign({}, data));
                        }
                    } },
                    react_1.default.createElement("g", { className: 'grid', id: 'grid' }),
                    react_1.default.createElement("g", { className: 'g_nodes', id: 'g_nodes', style: { 'position': position, /*'fontFamily': node_font */ } }),
                    react_1.default.createElement("g", { className: 'g_links', id: 'g_links', style: { 'position': position, /*'fontFamily': node_font */ } }),
                    react_1.default.createElement("g", { className: 'g_legend', id: 'g_legend' })))),
        agregation_node !== '' && data.nodes[agregation_node] ?
            react_1.default.createElement(SankeyLayout_1.AgregationModal, { show_agregation: show_agregation, data: data, set_data: set_data, agregation_node: agregation_node, set_show_agregation: set_show_agregation, is_agregation: is_agregation }) : react_1.default.createElement(react_1.default.Fragment, null)));
};
// Function used to handle event when some key are pressed
// If the keyboard arrows are pressed it shift the selected nodes according to the arrow direction and the grid square
// Escape key open and close configuration sankey menu
// ctrl + s save a view of the data
// Delete key allow us to delete selected elments (nodes,links, free label)
const keyHandler = (e, data, multi_selected_nodes, multi_selected_links, set_data, accordion_ref, button_ref, set_show_nav, mode_selection) => {
    var _a, _b, _c, _d;
    if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key) && ((((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.tagName) === 'INPUT') ? d3.select(document.activeElement).attr('value') === 'menuConfigButton' : true)) {
        // Deplace les noeuds sélectionné avec les flèches du clavier, cependant ne ce déplace pas si jamais on utilise les flèches pour dépalcer le curseur dans un input 
        // (exemples : le input de la largeur minimal d'un noeud)
        if (e.key == 'ArrowUp') {
            Object.values(data.nodes).filter(f => multi_selected_nodes.current.map(d => {
                if (d != undefined) {
                    return d.name;
                }
            }).includes(f.name)).map(d => {
                if (d.position === 'relative') {
                    return;
                }
                if (e.shiftKey) {
                    d.y = d.y - data.grid_square_size;
                }
                else {
                    const height = +d3.select(' .opensankey #' + d.idNode).attr('height');
                    const n_pos = Math.trunc((d.y + height / 2) / data.grid_square_size);
                    d.y = (n_pos - 1) * data.grid_square_size;
                    d.y += (data.grid_square_size / 2) - height / 2;
                }
                let y_max = 0;
                Object.values(data.nodes).map(d => {
                    y_max = (d.y > y_max) ? d.y : y_max;
                });
                //Diminue hauteur svg si le noeud est près du bord
                if (y_max < data.height - 100 && data.height - 100 >= window.innerHeight) {
                    data.height -= 90;
                }
            });
        }
        else if (e.key == 'ArrowDown') {
            Object.values(data.nodes).filter(f => multi_selected_nodes.current.map(d => {
                if (d != undefined) {
                    return d.name;
                }
            }).includes(f.name)).map(d => {
                if (d.position === 'relative') {
                    return;
                }
                if (e.shiftKey) {
                    d.y = d.y + data.grid_square_size;
                }
                else {
                    const height = +d3.select(' .opensankey #' + d.idNode).attr('height');
                    const n_pos = Math.trunc((d.y + height / 2) / data.grid_square_size);
                    d.y = (n_pos + 2) * data.grid_square_size;
                    d.y -= (data.grid_square_size / 2) + height / 2;
                }
                //Augumente hauteur svg si le noeud est près du bord
                if (d.y > data.height - 100) {
                    data.height += 100;
                }
            });
        }
        else if (e.key == 'ArrowLeft') {
            Object.values(data.nodes).filter(f => multi_selected_nodes.current.map(d => {
                if (d != undefined) {
                    return d.name;
                }
            }).includes(f.name)).map(d => {
                if (d.position === 'relative') {
                    return;
                }
                if (e.shiftKey) {
                    d.x = d.x - data.grid_square_size;
                }
                else {
                    const n_pos = Math.trunc(d.x / data.grid_square_size);
                    d.x = (n_pos * data.grid_square_size == d.x) ? (n_pos - 1) * data.grid_square_size : n_pos * data.grid_square_size;
                    const width = +d3.select(' .opensankey #' + d.idNode).attr('width');
                    d.x -= (data.grid_square_size / 2) + width / 2;
                }
                //Diminue largeur svg si le noeud est près du bord
                if (d.x < data.width - 100 && data.width - 100 >= window.innerWidth - 40) {
                    data.width -= 50;
                }
            });
        }
        else if (e.key == 'ArrowRight') {
            Object.values(data.nodes).filter(f => multi_selected_nodes.current.map(d => {
                if (d != undefined) {
                    return d.name;
                }
            }).includes(f.name)).map(d => {
                if (d.position === 'relative') {
                    return;
                }
                if (e.shiftKey) {
                    d.x = d.x + data.grid_square_size;
                }
                else {
                    const n_pos = Math.trunc(d.x / data.grid_square_size);
                    d.x = (n_pos + 2) * data.grid_square_size;
                    const width = +d3.select(' .opensankey #' + d.idNode).attr('width');
                    d.x += (data.grid_square_size / 2) - width / 2;
                }
                //Augumente largeur svg si le noeud est près du bord
                if (d.x > data.width - 100) {
                    data.width += 100;
                }
            });
        }
        set_data(Object.assign({}, data));
    }
    else if (e.key == 'Escape') {
        mode_selection.current = 's';
        set_show_nav(false);
        // set_mode_selection('s')
        if (button_ref && button_ref.current && accordion_ref) {
            button_ref.current.click();
        }
    } /*else if (e.key == 'z' && (e.ctrlKey||e.metaKey)) {
      e.preventDefault()
      //va chercher les différences sauvegardées dans le localStorage
      // const differences = JSON.parse(localStorage.getItem('diff') as string)
      const differences_str = LZString.decompress(localStorage.getItem('diff') as string) as string
      const differences = (differences_str != '') ? JSON.parse(differences_str) : undefined
      //Si il y a des différences, prend la dernière effectuée
      if (differences !== undefined && differences.length != 0) {
        type difference_type = {
          kind: string,
          path: string[],
          item: {
            rhs: string,
            kind: string
          },
          rhs: string,
          index: string
        }
        const difference = differences.pop() as difference_type[]
        //On crée une copie de data que l'on utilise ensuite pour pouvoir le parcourir et modifié
        //La copie nous permet de reffecter une variable avec d'autre type d'objet
        //Nous ne pouvons pas prendre ddirectement data car c'est un composant régis par des paramètre obligatoire
        //element_to_delete change de type au fur et à mesure qu'il parcours les chemins des différences
        let dt = JSON.parse(JSON.stringify(data))
        //Parcours les dernières modifications à effectuer
        //D : Supprime un objet qui a été ajouté
        //N : Rajoute un objet qui a été supprimé avec les mêmes propriétés
        //A : Annule des moddification faites à des array
        //E : Annule des modifications faites à des propriétées de l'objet
        //path : Tableau contenant le chemin vers la propriété modifié/ajouté/supprimé
        // Exemple : path=['P1','P2'] --> {P1:{P2:Propriété modifié}}
        difference.map(d => {
          let element_to_delete = dt
          if (d['kind'] == 'D') {
            let cpt = 0
            d.path.map(dd => {
              cpt++
              if (cpt == d['path'].length) {
                delete element_to_delete[dd]
              } else {
                element_to_delete = element_to_delete[dd]
              }
            })
          } else if (d['kind'] == 'N') {
            let cpt = 0
            d.path.map(dd => {
              cpt++
              if (cpt == d['path'].length) {
                element_to_delete[dd] = d['rhs']
              } else {
                element_to_delete = element_to_delete[dd]
              }
            })
          } else if (d['kind'] == 'A') {
            let cpt = 0
            d.path.map(dd => {
              cpt++
              if (cpt == d['path'].length) {
                if (d['item']['kind'] == 'N') {
                  element_to_delete[dd].splice(d['index'], 0, d['item']['rhs'])
                } else if (d['item']['kind'] == 'D') {
                  element_to_delete[dd].splice(d['index'], 1)
                }
              } else {
                element_to_delete = element_to_delete[dd]
              }
            })
          } else if (d['kind'] == 'E') {
            let cpt = 0
            if (d.path !== null && d.path !== undefined) {
              d.path.map(dd => {
                cpt++
                if (cpt == d['path'].length) {
                  element_to_delete[dd] = d['rhs']
                } else {
                  element_to_delete = element_to_delete[dd]
                }
              })
            } else {
              dt = d['rhs']
            }
          }
        })
        data = dt
        localStorage.setItem('diff', JSON.stringify(differences))
        try {
          //Permet d'éviter qu'une vue soit stocké en tant que données dans la naviguateur
          localStorage.setItem('data', LZString.compress(JSON.stringify(data)))
        } catch (e) {
          localStorage.clear()
        }
        set_data({ ...data })
      } else {
        console.log('Aucune action en mémoire pour un retour en arrière')
      }
    }*/
    else if (e.key == 'Delete') {
        if (((_b = document.activeElement) === null || _b === void 0 ? void 0 : _b.tagName) !== 'INPUT' || d3.select(document.activeElement).attr('value') == 'menuConfigButton') {
            multi_selected_links.current.forEach(el => {
                SankeyUtils_1.delete_link(data, el);
            });
            multi_selected_nodes.current.forEach(el => {
                SankeyUtils_1.delete_node(data, el);
            });
            multi_selected_nodes.current = [];
            multi_selected_links.current = [];
            set_data(Object.assign({}, data));
        }
    }
    else if (e.key == 'a' && e.ctrlKey) {
        e.preventDefault();
        multi_selected_nodes.current = Object.values(data.nodes);
        set_data(Object.assign({}, data));
    }
    else if (e.key == 'Enter' && ((_c = document.activeElement) === null || _c === void 0 ? void 0 : _c.tagName) == 'INPUT' && ((_d = document.activeElement) === null || _d === void 0 ? void 0 : _d.className.includes('form-control'))) {
        for (const item of document.getElementsByTagName('input')) {
            if (item.className.includes('form-control') && item.type == 'text') {
                item.blur();
            }
        }
    }
};
exports.keyHandler = keyHandler;
SankeyDraw.propTypes = SankeyDrawPropTypes;
SankeyDraw.defaultProps = exports.SankeyDrawDefaultProps;
exports.default = SankeyDraw;
